var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    fillRule: "evenodd",
    d: "M12 5C7.415 5 3.256 7.487.188 11.526a.935.935 0 0 0 0 1.125C3.256 16.695 7.415 19.18 12 19.18c4.586 0 8.744-2.486 11.812-6.526a.935.935 0 0 0 0-1.124C20.744 7.487 16.585 5 12 5m.329 12.084c-3.044.19-5.558-2.297-5.366-5.32.157-2.491 2.194-4.51 4.708-4.666 3.044-.19 5.558 2.297 5.366 5.319-.162 2.487-2.2 4.507-4.708 4.667M9.29 11.916c-.108 1.625 1.247 2.964 2.887 2.861a2.72 2.72 0 0 0 2.538-2.516c.108-1.625-1.247-2.964-2.887-2.861-1.355.087-2.455 1.172-2.538 2.516",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShow);
export default __webpack_public_path__ + "static/media/icon-show.4edcbc331c44aed96b3b9ac9992bf833.svg";
export { ForwardRef as ReactComponent };